export const createCharacterPageMessages = {
  title: 'Create A Character',
} as const;
